import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20.9614 15.9886C20.8246 15.6766 20.6422 15.3855 20.437 15.1152C19.3883 13.7012 17.7695 12.7654 15.9456 12.5367C15.7176 12.5159 15.4668 12.5575 15.2844 12.6822C14.3268 13.3269 13.1869 13.6596 12.0013 13.6596C10.8157 13.6596 9.67575 13.3269 8.71817 12.6822C8.53576 12.5575 8.28496 12.4951 8.05699 12.5367C6.23304 12.7654 4.5915 13.7012 3.56554 15.1152C3.36035 15.3855 3.17794 15.6974 3.04117 15.9886C2.97279 16.1133 2.99557 16.2589 3.06395 16.3837C3.24636 16.6748 3.47434 16.9659 3.67953 17.2154C3.99871 17.6106 4.34071 17.964 4.72831 18.2967C5.04749 18.5879 5.41227 18.8582 5.7771 19.1285C7.57822 20.3554 9.74418 21 11.9785 21C14.2128 21 16.3788 20.3554 18.1799 19.1285C18.5447 18.879 18.9095 18.5879 19.2287 18.2967C19.5935 17.964 19.9583 17.6105 20.2775 17.2154C20.5055 16.9451 20.7107 16.6748 20.8931 16.3837C21.007 16.2589 21.0298 16.1133 20.9614 15.9886Z",
  fill: "#86899E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.4999 7.5C16.4999 9.98528 14.4852 12 11.9999 12C9.5146 12 7.49988 9.98528 7.49988 7.5C7.49988 5.01472 9.5146 3 11.9999 3C14.4852 3 16.4999 5.01472 16.4999 7.5Z",
  fill: "#86899E"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }